import React from 'react';
import { useLocation } from 'react-router-dom';
import MobileHeader from './MobileHeader';
import BottomNavigation from './BottomNavigation';

interface MobileLayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showBottomNav?: boolean;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  showHeader = true,
  showBottomNav = true,
}) => {
  const location = useLocation();

  const hideNavRoutes = ['/login', '/register', '/forgot-password'];
  const shouldHideNav = hideNavRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--pw-bg)',
        paddingBottom: shouldHideNav ? 0 : 'calc(80px + env(safe-area-inset-bottom))',
      }}
    >
      {showHeader && !shouldHideNav && <MobileHeader />}
      <main>{children}</main>
      {showBottomNav && !shouldHideNav && <BottomNavigation />}
    </div>
  );
};

export default MobileLayout;
